import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckSquare } from "@fortawesome/free-regular-svg-icons/faCheckSquare";
import * as R from "ramda";
import React, { useEffect, useState } from "react";
import { InputNumerico } from "../inputs/InputNumerico";
import { useFormik } from "formik";
import clsx from "clsx";
import { Dialog, DialogActions, DialogContent } from "@mui/material"
import { PaperArrastavel } from "../dialog-arrastavel/PaperArrastavel"
import { ServicoAgregado, ServicoAgregadoEntity } from "app/types/ServicoAgregado";
import { Paginacao } from "../itens-orcamento/paginacao/Paginacao";
import { faTimes } from "@fortawesome/free-solid-svg-icons/faTimes";

const estiloServicosAgregados = require("./modal-servicos-agregados.module.scss").default;
const estiloTabela = require('../../estilos/tabelas.module.scss').default



export type ModalServicosAgregadosProps = {
    codigo: string;
    descricao: string;
    dados: ServicoAgregado;
    servicosAgregadosSelecionados?: ServicoAgregadoEntity[];
    corSelecionado: string;
    textoSelecionado: string;
    identificadorItem: number;
    precoProduto: number;
    processando: boolean;
    onObterListaServicosAgregadosPorPagina: (numerodaPagina: number) => void;
    onSalvar: (identificadorItem: number, agregadosSelecionados: ServicoAgregadoEntity[]) => void;
    onFecharModal: (e: any) => void;
};

export const ModalServicosAgregados = (props: ModalServicosAgregadosProps) => {
    const [servicosAgregadosSelecionados, setServicosAgregadosSelecionados] = useState<ServicoAgregadoEntity[]>(props.servicosAgregadosSelecionados ?? []);
    const [listaServicosAgregados, setlistaServicosAgregados] = useState<ServicoAgregadoEntity[]>(props.dados?.Entities ?? []);
    const [resetPreco, setResetPreco] = useState(0);
    const [resetPercentual, setResetPercentual] = useState(0);

    const formik = useFormik({
        initialValues: { ...props.dados },
        onSubmit: (values, { }) => { },
        enableReinitialize: true,
    });

    const toggleServicosAgregadosSelecionado = (servicoAgregado: ServicoAgregadoEntity) => {
        if (servicosAgregadosSelecionados.some(e => e.CodigoServicoAgregado === servicoAgregado.CodigoServicoAgregado)) {
            setServicosAgregadosSelecionados(
                R.filter((e) => e.CodigoServicoAgregado != servicoAgregado.CodigoServicoAgregado, servicosAgregadosSelecionados)
            );
        } else {
            setServicosAgregadosSelecionados(servicosAgregadosSelecionados.concat(servicoAgregado));
        }
    };

    const toggleServicosAgregadosSelecionadoInput = (event: any, servicoAgregado: ServicoAgregadoEntity) => {
        event.stopPropagation();
       if (servicosAgregadosSelecionados.some(e => e.CodigoServicoAgregado === servicoAgregado.CodigoServicoAgregado)) {

        } else {
            setServicosAgregadosSelecionados(servicosAgregadosSelecionados.concat(servicoAgregado));
        }
    };

    const onChangePrecoServico = (index: number, preco: number) => {
        if (isNaN(preco) || preco <= 0) {
            setResetPreco(prev => prev + 1);
            formik.setFieldValue("listaServicosAgregagados", props.dados);
            setlistaServicosAgregados(props.dados?.Entities ?? []);
        } else {
            setlistaServicosAgregados(prev => {
                const novaLista = prev.map((item, i) =>
                    i === index
                        ? {
                            ...item,
                            ValorServico: preco,
                            PercentualServico: preco > 0 ? (preco * 100) / props.precoProduto : item.PercentualServico
                        }
                        : item
                );
                return novaLista;
            });
        }
    }

    const onChangePercentualServico = (index: number, percentual: number) => {
        if (isNaN(percentual) || percentual <= 0) {
            setResetPercentual(prev => prev + 1);
            formik.setFieldValue("listaServicosAgregagados", props.dados);
            setlistaServicosAgregados(props.dados?.Entities ?? []);
        } else {
            setlistaServicosAgregados(prev => {
                const novaLista = prev.map((item, i) =>
                    i === index
                        ? {
                            ...item,
                            PercentualServico: percentual,
                            ValorServico: percentual > 0 ? (percentual * props.precoProduto) / 100 : item.ValorServico
                        }
                        : item
                );
                return novaLista;
            });
        }
    }

    const onSalvar = () => {
        var servicosAregadosSelecionadosComValoresAtualizados = servicosAgregadosSelecionados.map(
            servico => ({ ...servico, 
                ValorServico: listaServicosAgregados.find(x => x.CodigoServicoAgregado == servico.CodigoServicoAgregado).ValorServico,
                PercentualServico: listaServicosAgregados.find(x => x.CodigoServicoAgregado == servico.CodigoServicoAgregado).PercentualServico,
            })
        )
        props.onSalvar(props.identificadorItem, servicosAregadosSelecionadosComValoresAtualizados)
    }

    const paginacao = props.dados?.PageCount > 1 && (
        <Paginacao
          paginaAtual={props.dados?.ActualPage}
          totalPaginas={props.dados?.PageCount}
          id="modalServicosAgregados_Paginacao"
          onAlterarListaSelecionada={props.onObterListaServicosAgregadosPorPagina}
          
        />
      )

    const botaoSelecionarTodos = <button
        className={`no-global-button ${estiloServicosAgregados.button_check}`}
        id="modalServicosAgregados_button_SelecionarTodos"
        onClick={() => {
            const entidades = props.dados?.Entities ?? []

            setServicosAgregadosSelecionados(
                entidades.length != servicosAgregadosSelecionados.length ? entidades : []
            );
        }}
    >
        <FontAwesomeIcon
            color="#3c8ac9"
            className={estiloServicosAgregados.icone_check}
            icon={faCheckSquare}
            fontSize={"23px"}
        />
        Selecionar todos
    </button>

    const detalheProdutoSelecionado = <div className={estiloServicosAgregados.form}
        id="modalServicosAgregados_detalheProdutoSelecionado"
    >
        <label>Produto</label>
        <div>{props.codigo}</div>
        <label>Descrição</label>
        <div>{props.descricao}</div>
    </div>

    const botaoSalvar = 
    <div>
    <div //className="_absolute" 
        //style={{ right: "2%" }}
        >
    <button
        className={estiloServicosAgregados.button}
        id="modalServicosAgregados_button_Salvar"
        disabled={props.processando}
        type="button"
        title="Adicionar os serviços agregados selecionados no item do pedido"
        onClick={onSalvar}
    >
        Adicionar
    </button>
</div>
</div>

    const colunas = [
        { texto: "Código", coluna: "Codigo", estilo: "_text-left" },
        { texto: "Descrição", coluna: "Descricao", estilo: "_text-left" },
        { texto: "Percentual do Serviço", coluna: "PercentualServico", estilo: "_text-right" },
        { texto: "Valor do Serviço", coluna: "ValorServico", estilo: "_text-right" },
    ];

    const cabecalhoTabelaServicosAgregados = () => (
        <thead>
            <tr
                id="modalServicosAgregados_Linha_cabecalhoTabelaServicosAgregados"
            >
                {colunas.map((x) => <th 
                    key={x.coluna} 
                    className={`${x.estilo}`}
                    style={{ width: x.coluna == "ValorServico" ? "160px" : "" }}
                 >
                        {x.texto}
                </th>)}
            </tr>
        </thead>
    )

    return (
        <>
            <Dialog
                open={true}
                id="modalServicosAgregados"
                //fullWidth
                maxWidth="md"
                //onClose={(e) => props.onFecharModal(e)}
                PaperComponent={PaperArrastavel}
            >

                <DialogContent
                    style={{ paddingBottom: "0px", padding: "15px", backgroundColor: '#F2F2F2' }}
                    id="modalServicosAgregados_content"
                >
                    <div
                        className={estiloServicosAgregados.separador}
                        //style={{ marginRight: "40px" }}
                        id="modalServicosAgregados_Div"
                    >

                <div className="_absolute" style={{ right: "2%" }}>
                            <button onClick={(e) => { props.onFecharModal(e) }}
                                id="modalServicosAgregados_button_Fechar"
                                title="Fechar"
                                >
                                     <FontAwesomeIcon icon={faTimes} color={"#fff"}  />
                                </button>
                        </div>

                        {detalheProdutoSelecionado}
                        {botaoSelecionarTodos}

                        <div className={estiloTabela.containerRolavel}>
                            <table className={`_table _w-full _border-collapse ${estiloTabela.tabela} ${estiloServicosAgregados.tabelaServicosAgregados}`}>
                                {cabecalhoTabelaServicosAgregados()}
                                <tbody>

                                    {listaServicosAgregados?.map((dado, index) => {
                                        return (
                                            <tr
                                                key={dado.CodigoServicoAgregado}
                                                id="modalServicosAgregados_Linha_tabelaServicosAgregados"
                                                className={`_table-row  ${servicosAgregadosSelecionados.some(e => e.CodigoServicoAgregado === dado.CodigoServicoAgregado)
                                                    ? estiloServicosAgregados.linhaSelecionada
                                                    : estiloServicosAgregados.linha
                                                    }`}
                                                style={
                                                    servicosAgregadosSelecionados.some(e => e.CodigoServicoAgregado === dado.CodigoServicoAgregado)
                                                        ? {
                                                            backgroundColor: props.corSelecionado,
                                                            color: props.textoSelecionado,
                                                        }
                                                        : {}
                                                }
                                                onClick={() => {
                                                    toggleServicosAgregadosSelecionado(dado);
                                                }}
                                            >
                                                <td
                                                    style={{
                                                            width: "70px",
                                                        }}
                                                    >{dado.CodigoServicoAgregado}</td>
                                                <td className="_text-left"
                                                    
                                                >
                                                    {dado.DescricaoServicoAgregado}</td>
                                                <td 
                                                    className={estiloServicosAgregados.colunaInput}
                                                    id="modalServicosAgregados_td_PercentualServico"
                                                    onClick={(e) => {
                                                        toggleServicosAgregadosSelecionadoInput(e, dado)
                                                    }}
                                                    style={{
                                                        textAlign: "right",
                                                        width: "50px",
                                                    }}
                                                >
                                                    {dado.EhPercentual ? (
                                                    <InputNumerico
                                                        key={resetPercentual}
                                                        onValorModificado={(valor) => {
                                                            onChangePercentualServico(index, valor)
                                                        }}
                                                        numeroCasasDecimais={2}
                                                        selecionaValorOnFocus={true}
                                                        campoNullavel={true}
                                                        id="modalServicosAgregados_input_PercentualServico"
                                                        valor={dado.PercentualServico}
                                                        style={{
                                                            width: "50px",
                                                            color: "var(--mu-texto, #000000)",
                                                        }}
                                                    />) : (
                                                        dado.PercentualServico ? `${dado.PercentualServico.toFixed(2).replace('.', ',')}` : null
                                                    )}%
                                                </td>
                                                <td
                                                    className={estiloServicosAgregados.colunaInput}
                                                    id="modalServicosAgregados_td_ValorServico"
                                                    onClick={(e) => {
                                                        toggleServicosAgregadosSelecionadoInput(e, dado)
                                                    }}
                                                    style={{
                                                        width: "160px",
                                                        textAlign: "right",
                                                    }}
                                                >
                                                    {/* <div onClick={(e) => {
                                                        toggleServicosAgregadosSelecionadoInput(e, dado)
                                                    }}
                                                    style={{
                                                        width: "160px",
                                                    }} 
                                                    >*/}
                                                        {dado.EhPercentual ? (
                                                            dado.ValorServico ? `R$ ${dado.ValorServico.toFixed(2).replace('.', ',')}` : null
                                                        ) :   (<span className={'_flex'}>R$
                                                        <InputNumerico
                                                            key={resetPreco}
                                                            onValorModificado={(valor) => {
                                                                onChangePrecoServico(index, valor)
                                                            }}
                                                            numeroCasasDecimais={2}
                                                            selecionaValorOnFocus={true}
                                                            campoNullavel={true}
                                                            id="modalServicosAgregados_input_ValorServico"
                                                            valor={dado.ValorServico}
                                                            style={{
                                                                width: "136px",
                                                                //maxWidth: "150px",
                                                                color: "var(--mu-texto, #000000)",
                                                            }}
                                                        /></span>) }
                                                    {/* </div> */}
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                            <div>
                                    {paginacao}
                            </div>
                            

                        </div>
                        {/* <div>
                            {botaoSalvar}
                        </div> */}
                    </div>
                </DialogContent>
                <DialogActions style={{ paddingTop: "0px", paddingRight: "15px", backgroundColor: '#F2F2F2' }}>
                    {botaoSalvar}
                </DialogActions>
            </Dialog>
        </>
    )
}